"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _reactResponsive = require("react-responsive");

var _StyledTypography = require("../../../../../StyledTypography");

var _StyledLayout = require("../../../../../StyledLayout");

var _Elements = require("../../../../Elements");

var _Elements2 = require("./Elements");

var _helpers = require("../../../../common/helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var About = function About(_ref) {
  var cover = _ref.cover,
      description = _ref.description,
      setCanScroll = _ref.setCanScroll,
      isTypeTheme = _ref.isTypeTheme,
      vh1 = _ref.vh1,
      location = _ref.location;
  var aboutBoxRef = (0, _react.useRef)(null);
  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var isTabletLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1024px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  (0, _react.useEffect)(function () {
    setCanScroll(true);
    return function () {
      return setCanScroll(false);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var _aboutBoxRef$current, _aboutBoxRef$current$, _aboutBoxRef$current2, _aboutBoxRef$current3;

    // eslint-disable-next-line no-unused-expressions
    aboutBoxRef === null || aboutBoxRef === void 0 ? void 0 : (_aboutBoxRef$current = aboutBoxRef.current) === null || _aboutBoxRef$current === void 0 ? void 0 : (_aboutBoxRef$current$ = _aboutBoxRef$current.focus) === null || _aboutBoxRef$current$ === void 0 ? void 0 : _aboutBoxRef$current$.call(_aboutBoxRef$current); // eslint-disable-next-line no-unused-expressions

    aboutBoxRef === null || aboutBoxRef === void 0 ? void 0 : (_aboutBoxRef$current2 = aboutBoxRef.current) === null || _aboutBoxRef$current2 === void 0 ? void 0 : (_aboutBoxRef$current3 = _aboutBoxRef$current2.scrollTo) === null || _aboutBoxRef$current3 === void 0 ? void 0 : _aboutBoxRef$current3.call(_aboutBoxRef$current2, 0, 0);
  }, []);
  var descriptionElements = (0, _helpers.generateParagraphs)({
    description: description,
    isDesktopSmall: isDesktopSmall
  });
  return /*#__PURE__*/_react["default"].createElement(_Elements2.AboutBox, {
    ref: aboutBoxRef,
    tabIndex: "0",
    pt: "md",
    isTabletPortrait: isTabletPortrait,
    isTypeTheme: isTypeTheme,
    vh1: vh1
  }, isDesktopSmall ? /*#__PURE__*/_react["default"].createElement(_StyledTypography.Headline, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    center: true,
    mb: "md",
    normal: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.caption.about"
  })) : /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingLarge, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    center: true,
    mb: "md",
    normal: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.caption.about"
  })), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    justify: "center",
    align: "center",
    column: !isDesktopSmall
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.CoverBox, {
    mr: isTabletLandScape ? 'lg' : '',
    isDesktopSmall: isDesktopSmall
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.Image, {
    src: cover
  })), /*#__PURE__*/_react["default"].createElement(_Elements2.IntroBox, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, descriptionElements), location && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: !isDesktopSmall,
    bold: true,
    portfolioForeground2: true,
    mb: "xs",
    mt: "sm",
    center: !isDesktopSmall
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.message.caption.location"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true,
    center: !isDesktopSmall,
    mb: "md"
  }, location)))));
};

About.defaultProps = {
  cover: '',
  vh1: null,
  location: ''
};
About.propTypes = {
  cover: _propTypes["default"].string,
  description: _propTypes["default"].string.isRequired,
  setCanScroll: _propTypes["default"].func.isRequired,
  isTypeTheme: _propTypes["default"].bool.isRequired,
  vh1: _propTypes["default"].number,
  location: _propTypes["default"].string
};
var _default = About;
exports["default"] = _default;